import { AmplitudePageName, track } from "utils/amplitude";
import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import styles from "./CategorySwitch.module.scss";
import getClasses from "utils/getClasses";
import {
  BLOG_CATEGORIES,
  BlogCategory,
} from "components/Blogging/constants/blog-categories";

interface Props {
  amplitudePageName: AmplitudePageName;
  currentCategory: BlogCategory;
  setCurrentCategory: (category: BlogCategory) => void;
}

const CategorySwitch: React.FC<Props> = ({
  amplitudePageName,
  currentCategory,
  setCurrentCategory,
}) => {
  const { isPhonePortrait } = usePhonePortraitContext();
  return (
    <div
      className={getClasses(
        styles["category-switch"],
        isPhonePortrait && styles["category-switch--phone"],
      )}
    >
      {BLOG_CATEGORIES.map((category) => {
        const link = category.value ? `/blogs/${category.value}` : "/blogs";
        return (
          <a
            href={link}
            className={getClasses(
              styles["category-pill"],
              category === currentCategory && styles["category-pill--active"],
            )}
            key={category.value}
            onClick={(event) => {
              event.preventDefault();
              track(amplitudePageName, "category-switch", "click", {
                eventProperties: { category },
              });
              setCurrentCategory(category);
              window.history.pushState({}, "", link);
            }}
          >
            {category.label}
          </a>
        );
      })}
    </div>
  );
};

export default CategorySwitch;
